const ZoomInIcon = (props) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.25 36.3125C9.835 36.3125 2.1875 28.665 2.1875 19.25C2.1875 9.835 9.835 2.1875 19.25 2.1875C28.665 2.1875 36.3125 9.835 36.3125 19.25C36.3125 28.665 28.665 36.3125 19.25 36.3125ZM19.25 4.8125C11.2875 4.8125 4.8125 11.2875 4.8125 19.25C4.8125 27.2125 11.2875 33.6875 19.25 33.6875C27.2125 33.6875 33.6875 27.2125 33.6875 19.25C33.6875 11.2875 27.2125 4.8125 19.25 4.8125Z"
      fill="currentColor"
    />
    <path
      d="M23.625 20.5625H14.875C14.1575 20.5625 13.5625 19.9675 13.5625 19.25C13.5625 18.5325 14.1575 17.9375 14.875 17.9375H23.625C24.3425 17.9375 24.9375 18.5325 24.9375 19.25C24.9375 19.9675 24.3425 20.5625 23.625 20.5625Z"
      fill="currentColor"
    />
    <path
      d="M19.25 24.9375C18.5325 24.9375 17.9375 24.3425 17.9375 23.625V14.875C17.9375 14.1575 18.5325 13.5625 19.25 13.5625C19.9675 13.5625 20.5625 14.1575 20.5625 14.875V23.625C20.5625 24.3425 19.9675 24.9375 19.25 24.9375Z"
      fill="currentColor"
    />
    <path
      d="M35.2799 39.8825C35.1399 39.8825 34.9999 39.865 34.8774 39.8475C34.0549 39.7425 32.5674 39.1825 31.7274 36.68C31.2899 35.3675 31.4474 34.055 32.1649 33.0575C32.8824 32.06 34.0899 31.5 35.4724 31.5C37.2574 31.5 38.6574 32.1825 39.2874 33.39C39.9174 34.5975 39.7424 36.1375 38.7449 37.625C37.5024 39.4975 36.1549 39.8825 35.2799 39.8825ZM34.2299 35.8575C34.5274 36.7675 34.9474 37.2225 35.2274 37.2575C35.5074 37.2925 36.0324 36.96 36.5749 36.1725C37.0824 35.42 37.1174 34.8775 36.9949 34.6325C36.8724 34.3875 36.3824 34.125 35.4724 34.125C34.9299 34.125 34.5274 34.3 34.2999 34.5975C34.0899 34.895 34.0549 35.35 34.2299 35.8575Z"
      fill="currentColor"
    />
  </svg>
);
export default ZoomInIcon;
